var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTriangleGuidedPractice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_143567",
    "data-name": "Path 143567",
    d: "M23.515.191,2.808-20.515A1.611,1.611,0,0,0,1.657-21,1.644,1.644,0,0,0,0-19.351V1.355A1.645,1.645,0,0,0,1.645,3H22.351A1.645,1.645,0,0,0,23.515.191ZM2.25.75V-17.891l2.957,2.957-.53.53a.75.75,0,0,0,0,1.061l.53.53a.75.75,0,0,0,1.061,0l.53-.53,2.122,2.121-.53.53a.75.75,0,0,0,0,1.061l.53.53a.75.75,0,0,0,1.061,0l.53-.53L12.631-7.51l-.53.53a.75.75,0,0,0,0,1.061l.53.53a.75.75,0,0,0,1.061,0l.53-.53L16.343-3.8l-.53.53a.75.75,0,0,0,0,1.061l.53.53a.75.75,0,0,0,1.061,0l.53-.53L20.891.75ZM6-3h5.838L6-8.838Z",
    transform: "translate(0 21)",
    fill: "#484848"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTriangleGuidedPractice);
export default __webpack_public_path__ + "static/media/Icon-Triangle-GuidedPractice.1f51d5f14f80d5e735210e2d302c0d94.svg";
export { ForwardRef as ReactComponent };